(function () {
  var lightbox = document.getElementById('lightbox');
  if (!lightbox) return;

  var img = lightbox.querySelector('img');
  var cap = lightbox.querySelector('.lb-cap');
  var closeBtn = lightbox.querySelector('.lb-close');

  function openLightbox(src, caption) {
    img.src = src;
    img.alt = caption || '';
    if (cap) cap.textContent = caption || '';
    lightbox.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.hidden = true;
    img.removeAttribute('src');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var tile = e.target.closest('.tile');
    if (tile && tile.dataset.full) {
      e.preventDefault();
      var captionEl = tile.querySelector('figcaption');
      openLightbox(tile.dataset.full, captionEl ? captionEl.textContent.trim() : '');
      return;
    }
    if (e.target === lightbox || e.target === closeBtn) {
      closeLightbox();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
  });
})();
